<template>
  <div>
    <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':c_mdshow}">
      <div class="md-modal-inner">
        <div class="md-top">
          <button class="md-close" @click='closeModal'>Close</button>
        </div>
        <div class="md-content">
          <div class="confirm-tips">
            <slot name="msg"></slot>
          </div>
          <div class="form">
            <el-form ref="form" :model="ruleForm" label-width="100px">
              <el-form-item label="收货人姓名">
                <el-input v-model="ruleForm.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="ruleForm.mobile" clearable></el-input>
              </el-form-item>
              <el-form-item label="省市区">
                <div class="linkage">
                  <el-select
                    class="region_input"
                    v-model="sheng"
                    @change="choseProvince"
                    placeholder="省级地区">
                    <el-option
                      v-for="item in province"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="shi"
                    @change="choseCity"
                    placeholder="市级地区">
                    <el-option
                      v-for="item in shi1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select
                    class="region_input"
                    v-model="qu"
                    @change="choseBlock"
                    placeholder="区级地区">
                    <el-option
                      v-for="item in qu1"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="详细地址">
                <el-input type="textarea" v-model="ruleForm.detailInfo" clearable></el-input>
              </el-form-item>
              <el-form-item label="设为默认">
                <el-switch v-model="ruleForm.default"></el-switch>
              </el-form-item>
              <el-form-item id="submit">
                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                <el-button @click='closeModal'>取消</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn-wrap">
            <slot name="btnGroup"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class='md-overlay' v-if="c_mdshow" @click='closeModal'></div>
  </div>

</template>

<script>
  import axios from "axios"
  import "@/assets/css/index.css"
  import {getCookie,removeHTMLTag,isValidPhone,isValidName} from "../util/util";

  export default {
    data() {
      return {
        ruleForm: {
          name: '',
          mobile: '',
          detailInfo: '',
          default: false,
        },
        rules: {
          name: [
            {message: '请输入收货人姓名', trigger: 'blur'},
          ],
          mobile: [
            {message: '请输入活动名称', trigger: 'blur'}
          ],
          detailInfo: [
            {message: '请输入详细地址', trigger: 'blur'}
          ],
          // region:[
          //   {required: true}
          // ]
        },
        mapJson: '../../static/json/map.json',
        // mapJson: 'https://uat.liferiverai.cn/jyw-web/static/json/map.json',
        province: '',
        sheng: '',
        shi: '',
        shi1: [],
        qu: '',
        qu1: [],
        city: '',
        block: '',
      };
    },
    props: ['c_mdshow'],
    methods: {
      // 加载china地点数据，三级
      getCityData: function () {
        var that = this
        axios.defaults.baseURL = ''
        axios.get(this.mapJson).then(function (response) {
          axios.defaults.baseURL = process.env.API_ROOT
          if (response.status == 200) {
            var data = response.data
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (var item in data) {
              if (item.match(/0000$/)) {//省
                that.province.push({id: item, value: data[item], children: []})
              } else if (item.match(/00$/)) {//市
                that.city.push({id: item, value: data[item], children: []})
              } else {//区
                that.block.push({id: item, value: data[item]})
              }
            }
            // 分类市级
            for (var index in that.province) {
              for (var index1 in that.city) {
                if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                  that.province[index].children.push(that.city[index1])
                }
              }
            }
            // 分类区级
            for (var item1 in that.city) {
              for (var item2 in that.block) {
                if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                  that.city[item1].children.push(that.block[item2])
                }
              }
            }
          }
          else {
            console.log(response.status)
          }
        }).catch(function (error) {
          console.log(typeof+error)
        })
      },
      // 选省
      choseProvince: function (e) {
        for (var index2 in this.province) {
          if (e === this.province[index2].id) {
            this.sheng = this.province[index2].value
            this.shi1 = this.province[index2].children
            // this.shi = this.province[index2].children[0].value
            this.shi = ""
            this.qu1 = this.province[index2].children[0].children
            // this.qu = this.province[index2].children[0].children[0].value
            this.qu = ""
            this.E = this.qu1[0].id
          }
        }
      },
      // 选市
      choseCity: function (e) {
        for (var index3 in this.city) {
          if (e === this.city[index3].id) {
            this.shi = this.city[index3].value
            this.qu1 = this.city[index3].children
            // this.qu = this.city[index3].children[0].value
            this.qu = ""
            this.E = this.qu1[0].id
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        this.E = e;
        for (var index3 in this.block) {
          if (e === this.block[index3].id) {
            this.qu = this.block[index3].value
          }
        }
      },
      closeModal() {
        this.$emit('c_close')

      },
      onSubmit() {

        this.addAddress()

      },

      // 新增地址
      addAddress() {
        if (!this.ruleForm.name) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入收货人姓名'),
            type: 'error'
          });
          return false;
        }
        if (!isValidName(this.ruleForm.name)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('姓名不正确'),
            type: 'error'
          });
          return false;
        }
        if (!this.ruleForm.mobile) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入手机号'),
            type: 'error'
          });
          return false;
        }
        if (!isValidPhone(this.ruleForm.mobile)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('手机号不正确'),
            type: 'error'
          });
          return false;
        }
        if (!this.sheng) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请选择省级地区'),
            type: 'error'
          });
          return false;
        }
        if (!this.shi) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请选择市级地区'),
            type: 'error'
          });
          return false;
        }
        if (!this.qu) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请选择区级地区'),
            type: 'error'
          });
          return false;
        }
        axios.post("/jys/address", {
          userName:this.ruleForm.name,
          telNumber:this.ruleForm.mobile,
          provinceName: this.sheng,
          cityName: this.shi,
          countyName: this.qu,
          detailInfo:this.ruleForm.detailInfo,
          isDefault:this.ruleForm.default,
        }, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((respnse) => {
          if(respnse.data.code == 0){
            this.closeModal()
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.$emit('c_getList')
            this.ruleForm.name = ""
            this.ruleForm.mobile = ""
            this.sheng = ""
            this.shi = ""
            this.qu = ""
            this.ruleForm.detailInfo = ""
            this.ruleForm.default = false
          }
        })
      }
    }
  }
</script>
<style>
  /*.form{*/
  /*width: 100%;*/
  /*heigth:200px;*/
  /*}*/
  .el-switch.is-checked .el-switch__core {
    border-color: #00C5B0;
    background-color: #00C5B0;
  }

  .el-button--default:focus, .el-button--default:hover {
    border-color: #00C5B0;
    color: #00C5B0;
    background-color: #fff;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #00C5B0;
    border-color: #00C5B0;
    color: #ffffff;
  }

  .region_input {
    margin-bottom: 20px;
  }

  #submit {
    text-align: center;
  }

  #submit .el-form-item__content {
    margin-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddressModal.vue